import { FC } from 'react';

export type MarkIconProps = {};

export const MarkIcon: FC<MarkIconProps> = ({}) => (
  <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M53.3335 31.9997C53.3335 43.7818 43.7822 53.333 32.0002 53.333M53.3335 31.9997C53.3335 20.2176 43.7822 10.6663 32.0002 10.6663M53.3335 31.9997H58.6668M32.0002 53.333C20.2181 53.333 10.6668 43.7818 10.6668 31.9997M32.0002 53.333V58.6663M10.6668 31.9997C10.6668 20.2176 20.2181 10.6663 32.0002 10.6663M10.6668 31.9997H5.3335M32.0002 10.6663V5.33301M40.0002 31.9997C40.0002 36.418 36.4184 39.9997 32.0002 39.9997C27.5819 39.9997 24.0002 36.418 24.0002 31.9997C24.0002 27.5814 27.5819 23.9997 32.0002 23.9997C36.4184 23.9997 40.0002 27.5814 40.0002 31.9997Z"
      stroke="url(#paint0_linear_101_44433)"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_101_44433"
        x1="55.1327"
        x2="-0.0658109"
        y1="55.333"
        y2="44.0453"
      >
        <stop stop-color="#3EBDDA" />
        <stop offset="1" stop-color="#548CE4" />
      </linearGradient>
    </defs>
  </svg>
);
